import cn from 'classnames'
import { useTranslation } from '@mc/i18n'

export const ExpandCollapseButton = ({
  isExpanded,
  theme,
}: {
  isExpanded: boolean
  theme: 'light' | 'dark'
}) => {
  const { t } = useTranslation('@mc/certificates')

  const expandedClasses =
    theme === 'light'
      ? 'bg-c-beige-600 text-c-base-1400'
      : 'bg-c-beige-1400 text-c-brand-highlight'
  const collapsedClasses =
    theme === 'light'
      ? 'bg-c-base-700 text-c-base-1400'
      : 'bg-c-brand-highlight text-c-text-dark'
  const expandedBorder =
    theme === 'light'
      ? '2px solid var(--c-beige-1200)'
      : '2px solid var(--c-brand-highlight)'

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full mc-text-large ml-auto flex-none size-[32px] cursor-pointer',
        {
          [collapsedClasses]: !isExpanded,
          [expandedClasses]: isExpanded,
        },
      )}
      aria-expanded={isExpanded}
      aria-label={
        isExpanded
          ? t('marketingPages.common.faq.collapsedAriaLabel')
          : t('marketingPages.common.faq.expandedAriaLabel')
      }
      style={{
        border: isExpanded ? expandedBorder : 'none',
      }}
    >
      {isExpanded ? '−' : '+'}
    </div>
  )
}
